import { Component } from '@angular/core';
import { ReportShareComponent } from '../../report-share.component';

@Component({
  selector: 'app-coachee-primary-style',
  templateUrl: './coachee-primary-style.component.html'
})
export class CoacheePrimaryStyleComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.primaryCoachingStyleDesc?.replaceAll("\n","<br />") ?? '';
  }

}
